import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';

import { AppRouter } from './app/router';
import { i18n } from './lib/i18n';
import { AuthProvider } from './app/auth-context';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The shell is mostly auth-gated. Treat data as fresh for 30s; we'll
      // tighten or relax per-feature in R1.2+.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root missing — index.html is broken');
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
